import { render, staticRenderFns } from "./micoapp_info.vue?vue&type=template&id=396fc0c1&scoped=true"
import script from "./micoapp_info.vue?vue&type=script&lang=js"
export * from "./micoapp_info.vue?vue&type=script&lang=js"
import style0 from "./micoapp_info.vue?vue&type=style&index=0&id=396fc0c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396fc0c1",
  null
  
)

export default component.exports